import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-terms-of-services",
  imports: [],
  templateUrl: "./terms-of-services.component.html",
  styleUrl: "./terms-of-services.component.css",
})
export class TermsOfServicesComponent implements OnInit {

  lastUpdated: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute) {
    this.lastUpdated = new Date().toLocaleDateString();
  }

  ngOnInit(): void {}

  /**
   * When user clicks TOS on signup on PWA will be redirect to Angular TOS.
   * Return back to PWA on click back btn
   */
  goBack(): void {
    this.route.queryParamMap.subscribe(params => {
      const redirectBackTo = params.get('redirect-back-to');
      if (redirectBackTo && redirectBackTo == "app") {
        window.location.href = `${environment.pwaFrontendBaseUrl}/auth/signup`;
      } else {
        this.router.navigate([""]);
      }
      console.log("redirectBackTo: ", redirectBackTo);
    });
  }
}
